import { VCol } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VFooter,{staticClass:"footer",attrs:{"dark":"","padless":""}},[_c(VCol,{staticClass:"text-center"},[_vm._v("PROSIC © "+_vm._s(new Date().getFullYear())+" Todos los derechos\n    reservados.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }